const PRODUCTION_APP_MODE = 'prod';

export function canPickEnvironment(appMode?: string | null): boolean {
  return !!appMode && appMode !== PRODUCTION_APP_MODE;
}

export function defaultEnvironment<T extends string>(appMode: string | null | undefined, live: T, sandbox: T): T {
  return appMode === PRODUCTION_APP_MODE ? live : sandbox;
}

export function isProduction(appMode?: string | null): boolean {
  return appMode === PRODUCTION_APP_MODE || appMode === 'production';
}

export function showDevTools(appMode?: string | null): boolean {
  const isNonProd = !!appMode && !isProduction(appMode);
  // Recorded demo clips set this so non-prod chrome stays out of prospect-facing footage.
  return isNonProd && window.localStorage.getItem('NS_HIDE_DEV_TOOLS') !== '1';
}
